<template>
  <div class="list-item template-item">
    <v-list-item-avatar tile v-if="!isMobile">
      <v-img
        height="25px"
        contain
        src="@/assets/svg/question-template-icon.svg"
      />
    </v-list-item-avatar>
    <v-list-item-content>
      <div class="item-right">
        <div class="description justify-center">
          <div class="d-flex flex-column">
            <span class="font-weight-bold">
              {{ applicationQuestionTemplate.question }}
            </span>
            <span
              class="mr-1 mt-1 secondary-text"
              v-for="(term, index) in applicationQuestionTemplate.terms"
              :key="index"
            >
              {{ term }}
            </span>
          </div>
        </div>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
export default {
  props: {
    applicationQuestionTemplate: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scope></style>
